<div id="allQrCodeAllBulkDownload" #allQrCodeAllBulkDownload>
    <div class="generate_pdf html2pdf__page-break" *ngFor="let qrplant of seletedPlantToDownloadQr; let j=index">
        <div class="card_header">
            <a [routerLink]="['/']">
                <img src="./assets/images/capitaland-cla-logo.png" alt="">
            </a>
            <a [routerLink]="['/']">
                <img src="./assets/images/logo-cla.png" alt="">
            </a>
        </div>
        <p class="_location"> {{qrplant.parkName}}</p>
        <div class="_content">
            <h3>{{qrplant.vegetationName}}</h3>
            <p>({{qrplant.species}})</p>
            <div class="_qr">
                <img [src]="qrplant.qrCodePath" alt="qrcode" class="mb-3 mb-md-4">
            </div>
            <small>Scan this QR Code to view details about the plant</small>
        </div>
    </div>
</div>